<template>
  <div class="right">
    <div v-if="getCurrentUser && getCurrentUser.id > 0 && !$device.isMobileOrTablet" class="right_menu_top">
      <img
        v-lazy-load :data-src="getCurrentUser.profilePhotoThumbnail || getCurrentUser.image|| 'https://s3.amazonaws.com/app.770apps.images/defult_pic.png'"
        class="right_menu_user_icon pointer"
        @click="gooProfile()"
       alt="show profile">
      <div class="right_menu_name">
        <span class="pointer username" @click="gooProfile()">{{ getCurrentUser.username }}</span>
        <br>
        <span class="pointer name" @click="gooProfile()">{{ getCurrentUser.name }}</span>
      </div>
    </div>
    <div v-if="!editFeedCategory" class="category_breadcrumb" @click="editFeedCategory = true">
      <div class="underline">
        Showing: {{ genderFilter }} - {{ homeFilter }}
      </div>
      <div class="strech" />
      <div class="edit">
        Edit
      </div>
    </div>
    <div v-if="editFeedCategory" class="gender_filter">
      <dl :class="{'show': showGenderFilter}" class="sort">
        <dt>
          <a href="#" @click.stop="toggleGender()">{{ genderFilter }}</a>
        </dt>
        <dd v-if="!$device.isMobileOrTablet || showGenderFilter">
          <ul>
            <li v-for="(gender, index) in genderFilters" ref="filtersRef" :key="index">
              <a
                :class="{'highlight': genderFilter === gender.name }"
                @click.stop="onGenderFilterClick(gender)"
              >{{ gender.name }}</a>
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <div v-if="editFeedCategory" class="home_filter">
      <dl :class="{'show': showHomeFilter}" class="sort">
        <dt>
          <a href="#" @click.stop="toggleHomeFilters()">{{ homeFilter }}</a>
        </dt>
        <dd v-if="!$device.isMobileOrTablet || showHomeFilter">
          <ul>
            <li v-for="(filter, index) in homeFilters" ref="filtersRef" :key="index">
              <a
                :class="{'highlight': homeFilter === filter.name }"
                @click.stop="onHomeFilterClick(filter)"
              >{{ filter.name }}</a>
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <template v-if="homeFilters.length > 0 && !$device.isMobileOrTablet">
      <RecommendedItems class="box_container recommended_items" @navigate="navigate" />
      <div class="devider" />
      <LatestNews v-if="$store.state.localStorage.currentUser.id > 0" class="box_container" />
      <div v-if="$store.state.localStorage.currentUser.id > 0" class="devider" />
    </template>
  </div>
</template>
<script>
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import LatestNews from './LatestNews'
import RecommendedItems from './RecommendedItems'
import AbstractComponent from './AbstractComponent'

export default {
  name: 'RightComponent',
  components: { LatestNews, RecommendedItems },
  extends: AbstractComponent,
  data () {
    return {
      editFeedCategory: false,
      showGenderFilter: false,
      showHomeFilter: false,
      changeCategorySubject: new Subject(),
      genderFilter: '',
      homeFilter: '',
      genderFilters: [
        {
          name: 'All',
          filter: ''
        },
        {
          name: "Men's",
          filter: 'true'
        },
        {
          name: "Women's",
          filter: 'false'
        }
      ],
      homeFilters: [{ name: 'Following' }, { name: 'Everything' }, { name: 'Special Deals' }, { name: "Today's Most Wanted" }, { id: 102, createdAt: 1561903698000, updatedAt: 1664015499000, image: null, name: 'Matching Sets', itemsNum: null, nameLower: 'matching sets', pushDescriptor1: 'matching sets', pushDescriptor2: 'this matching set', hideFromHomeFeed: false, order: null, itemId1: 1154315, itemId2: 1154563, itemId3: 1153571 }, { id: 25, createdAt: 1423237042000, updatedAt: 1664015499000, image: 'http://files.parsetfss.com/5e76067c-8985-45fa-a6d4-073790b74d85/tfss-7337870d-730b-4bad-8343-cf94bd499a1c-Recommended.png', name: 'Recommended', itemsNum: 0, nameLower: 'recommended', pushDescriptor1: 'recommended item', pushDescriptor2: 'this recommended item', hideFromHomeFeed: false, order: 1, itemId1: 1154315, itemId2: 1154563, itemId3: 1154535 }, { id: 100, createdAt: 1487165190000, updatedAt: 1594816513000, image: 'http://files.parsetfss.com/5e76067c-8985-45fa-a6d4-073790b74d85/tfss-8d3529ee-1515-4540-bda4-e29850e7e3df-Women.jpg', name: 'Plus Size (New)', itemsNum: 0, nameLower: 'plus size (new)', pushDescriptor1: 'plus size item', pushDescriptor2: 'this plus size item', hideFromHomeFeed: false, order: 8, itemId1: 243495, itemId2: 242093, itemId3: 242007 }, { id: 101, createdAt: 1487165190000, updatedAt: 1556819148000, image: null, name: 'Subscriptions', itemsNum: 0, nameLower: 'subscriptions', pushDescriptor1: 'subscriptions item', pushDescriptor2: 'this subscriptions item', hideFromHomeFeed: false, order: 9, itemId1: 243922, itemId2: null, itemId3: null }],
      priceRangeFilter: ''
    }
  },
  computed: {
    getCurrentUser () {
      return this.$store.state.localStorage.currentUser
    }
  },
  mounted () {
    this.$root.$on('background_clicked', () => {
      this.showHomeFilter = false
      this.showGenderFilter = false
    })
    const genderFilter = this.$store.state.localStorage.genderFilter
    const homeFilter = this.$store.state.localStorage.homeFilter
    if (!genderFilter) {
      this.genderFilter = this.genderFilters[0].name
    } else {
      this.genderFilter = genderFilter
    }

    if (!homeFilter) {
      this.homeFilter = this.homeFilters[1].name
    } else {
      this.homeFilter = homeFilter
    }
    if (!this.$device.isMobileOrTablet) {
      this.changeCategorySubject
        .pipe(debounceTime(10000))
        .subscribe(() => {
          this.editFeedCategory = false
        })
    } else {
      this.editFeedCategory = true
    }
    const makeQueryParams = this.makeQueryParams()
    switch (genderFilter) {
      case 'Women\'s':
        makeQueryParams.gender = 'false'
        break
      case 'Men\'s':
        makeQueryParams.gender = 'true'
        break
    }
    this.$emit('homeFilterChanged', makeQueryParams)
  },
  methods: {
    navigate (path) {
      this.$emit('navigate', path)
    },
    makeQueryParams () {
      const homeFilterIndex = this.homeFilters
        .map(e => e.name)
        .indexOf(this.homeFilter)
      const genderFilterIndex = this.genderFilters
        .map(e => e.name)
        .indexOf(this.genderFilter)
      const queryArgsArrayList = {}
      queryArgsArrayList.includeComments = 'true'
      queryArgsArrayList.mainFeed = 'true'
      queryArgsArrayList.includeProperties = 'true'
      switch (homeFilterIndex) {
        case 0: {
          queryArgsArrayList.filter = 'FOLLOWING'
          break
        }
        case 1: {
          queryArgsArrayList.filter = 'ALL'
          break
        }
        case 2: {
          queryArgsArrayList.filter = 'FEATURED'
          queryArgsArrayList.filterParam = '1'
          break
        }
        case 3: {
          queryArgsArrayList.filter = 'WANTED'
          break
        }
        default: {
          if (homeFilterIndex < this.homeFilters.length) {
            queryArgsArrayList.filter = 'CATEGORIES'
            queryArgsArrayList.filterParam = this.homeFilters[
              homeFilterIndex
            ].id
          }
        }
      }
      switch (genderFilterIndex) {
        case 0: {
          break
        }
        case 1: {
          queryArgsArrayList.gender = 'true'
          break
        }
        case 2: {
          queryArgsArrayList.gender = 'false'
          break
        }
      }
      // console.log('queryArgsArrayList', queryArgsArrayList)
      return queryArgsArrayList
    },
    onGenderFilterClick (gender) {
      this.genderFilter = gender.name
      this.toggleGender()
      this.$store.commit('localStorage/setGenderFilter', this.genderFilter)
      const queryParams = this.makeQueryParams()
      queryParams.type = 'homeGenderFilter'
      this.$emit('homeFilterChanged', queryParams)
      this.changeCategorySubject.next('gender')
    },
    onHomeFilterClick (filter) {
      this.homeFilter = filter.name
      this.toggleHomeFilters()
      this.$store.commit('localStorage/setHomeFilter', this.homeFilter)
      this.$emit('homeFilterChanged', this.makeQueryParams())
      this.changeCategorySubject.next('filter')
    },
    gooProfile () {
      this.$router.push({
        path: '/profile'
      })
    },
    toggleGender () {
      this.showGenderFilter = !this.showGenderFilter
      this.showHomeFilter = false
    },
    toggleHomeFilters () {
      this.showHomeFilter = !this.showHomeFilter
      this.showGenderFilter = false
    },
    onPriceRangeClick (range) {
      this.priceRangeFilter = range.toPrice
        ? '$' + range.fromPrice + ' - $' + range.toPrice
        : '$' + range.fromPrice + '+'
      this.togglePriceRange()
      this.$store.commit('api/setPriceRangeFilter', range)
      this.$emit('filterProducts', { type: 'priceFilter', filter: range })
    }
  }
}
</script>
<style scoped>
.box_container {
  padding: 1em;
}

.right_menu_top {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #efefef;
  margin-bottom: 1em;
  overflow: scroll;
}

.right_menu_name {
  flex-grow: 1;
  text-align: left;
  margin-left: 0.7em;
}

.right_menu_name .username {
  font-size: 14px;
  /*font-family: "HKGroteskBold", serif;*/
  font-weight: bold;
}

.right_menu_name .name {
  font-size: 12px;
  color: #999999;
}

.right_menu_user_icon {
  width: 50px;
  height: 50px !important;
  border-radius: 50%;
}

/*aaaaaaa*/
dt a {
  background: #ed4956;
  /*background: #EBECED;*/
  line-height: 36px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  border-radius: 5px;
  text-decoration: none;
  display: block;
  color: white;
  padding: 0 28px 0 10px;
}

.mobile_design dt a {
  background: white;
  color: #ed4956;
  border-radius: 0;
}
dt a:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 9px;
  background: url("/ic_dropdown_white.svg") #ed4956 no-repeat 50% 50%;
  height: 5px;
  opacity: 0.6;
  margin: -3px 0 0;
}

.mobile_design a:before {
  background: url("/ic_dropdown.svg") white no-repeat 50% 50%;
}

dt a:hover {
  text-decoration: none;
}

li {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  list-style: none;
  quotes: none;
  font-style: normal;
  outline: none;
  -webkit-text-size-adjust: none;
  -webkit-overflow-scrolling: touch;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
}

dd {
  position: relative;
  margin-top: 0 !important;
  left: 3px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  visibility: hidden;
  padding: 7px 0;
  min-width: calc(100% - 6px);
  opacity: 0;
  z-index: 20;
  transition: opacity 0.3s;
  -webkit-transition: opacity 0.3s;
  -moz-transition: opacity 0.3s;
}

dl.show {
  z-index: 1;
  overflow: visible;
}

dl.show dd {
  opacity: 1;
  visibility: visible;
}

.mobile_design dl.show dd {
  position: absolute;
}

li a {
  display: block;
  border-radius: 0;
  white-space: nowrap;
  background: none;
  border: 0;
  box-shadow: none;
  text-shadow: none;
  font-size: 13px;
  line-height: 17px;
  padding: 6px 13px;
  color: #383d48;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  z-index: 20;
}

.highlight {
  color: #ed4956;
}

/*aaaaa*/

.home_filter {
  margin-top: -6em;
}

.recommended_items {
  margin-top: -16em;
}

.category_breadcrumb + .recommended_items {
  margin-top: 1em;
}

.edit_categories {
  height: 15px;
  width: 15px;
  margin-left: 1em;
}

.category_breadcrumb {
  padding: 1em;
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  text-align: right;
}
.underline {
  cursor: pointer;
  text-decoration: underline;
}

.edit {
  /*font-family: "HKGroteskBold", serif;*/
  font-weight: bold;
  color: #393995;
  cursor: pointer;
}

.mobile_design .right_component {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 7px;
}

.mobile_design .right_component > div {
  flex-grow: 1;
  margin: 1px;
}

.mobile_design .gender_filter {
  order: 2;
}

.mobile_design .home_filter {
  margin-top: unset;
  order: 1;
}

</style>
